<template>
  <FrameMobile>
    <template v-slot:header>
      <GeneralHeaderMobile :headerBackground="headerBackground" :title="title" />
    </template>

    <template v-slot:content>
      <!-- 購物流程 begin -->
      <div class="container h-100 overflow-auto py-4">
        <RedeemComplete></RedeemComplete>
      </div>
      <!-- 購物流程 end -->
    </template>
  </FrameMobile>

</template>

<script>
import FrameMobile from '@/components/mcf/FrameMobile.vue';
import GeneralHeaderMobile from '@/components/mcf/GeneralHeaderMobile.vue';
import RedeemComplete from '@/components/redeem/RedeemComplete.vue';

import pageSettingGetter from '@/utils/pageSettingGetter';

export default {
  components: {
    FrameMobile,
    GeneralHeaderMobile,
    RedeemComplete,
  },
  data() {
    return {
      // 標題
      title: '',
      // header背景圖
      headerBackground: '',
    };
  },
  created() {
    const vm = this;

    // 取得頁面設定
    vm.$store.dispatch('getPageSetting', 'RedeemItem')
      .then((setting) => {
        // 標題
        const title = pageSettingGetter.getFunctionWording(setting, 'TitleWording');
        document.title = title;
        vm.title = title;
        // header背景
        vm.headerBackground = setting.backgroundMobilePic;
      });
  },
};
</script>
